export default __webpack_public_path__ + "static/desktop_KV15-50010dd8f561d0208e635f2bd99e25e8.mp4";